<template>
    <div class="activation-form-area">
        <form class="activation-form" action method="POST">
            <div class="field">
                <div class="left">
                    <h1>Enter activation information</h1>
                </div>
            </div>
            <div class="field">
                <div class="left">
                    <label class="label" for="systemid">System Id :</label>
                </div>
                <div class="right">
                    <input
                        name="systemid"
                        id="systemid"
                        type="text"
                        autocomplete="off"
                        spellcheck="false"
                    >
                </div>
            </div>
            <div class="field">
                <div class="left">
                    <label class="label" for="pin">PIN :</label>
                </div>
                <div class="right">
                    <input
                        name="pin"
                        id="pin"
                        type="password"
                        autocomplete="off"
                        spellcheck="false"
                    >
                </div>
            </div>
            <div class="field">
                <a
                    id="activateButton"
                    href="#"
                    class="button right"
                    @click="onActivateClicked"
                >Activate</a>
            </div>
        </form>
    </div>
</template>

<script>
// import { constants } from "crypto";
export default {
    name: "ActivationForm",
    methods: {
        setBoxError(boxName) {
            let box = document.getElementById(boxName);
            let boxColor = box.style.backgroundColor;
            setTimeout((c = boxColor) => {
                box.style.backgroundColor = c;
            }, 1500);
            box.style.backgroundColor = "#FFCCCC";
        },

        onActivateClicked() {
            let systemIdBox = document.getElementById("systemid");
            let pinBox = document.getElementById("pin");

            if (systemIdBox.value == "") {
                this.setBoxError(systemIdBox.id);
            }

            if (pinBox.value == "") {
                this.setBoxError(pinBox.id);
            }

            if (systemIdBox.value != "" && pinBox.value != "") {
                this.$emit("Activate", {
                    systemId: systemIdBox.value,
                    pin: pinBox.value
                });
            }
        }
    }
};
</script>

<style>
.activation-form-area {
    display: table-cell;
    padding: 0px 0px 20px 0px;
    margin: 7px auto;
    text-align: center;
}

.activation-form h1 {
    color: #fff;
    font-size: 18px;
    font-weight: 300;
}

.left {
    float: left;
}

.right {
    float: right;
}

.field {
    padding: 6px 0;
    clear: both;
    text-align: left;
}

.activation-form {
    width: 540px;
    margin: 0 auto;
}

.activation-form input {
    font-size: 16px;
    width: 385px;
    color: #000;
    box-sizing: border-box;
    height: 44px;
    outline: 0;
    background-color: #fff;
    padding: 1px 1px 1px 18px;
    border: 0;
}

.activation-form label {
    color: #fff;
    font: 18px "Helvetica Neue", "Segoe UI", Helvetica, Arial, "Lucida Grande",
        sans-serif;
    font-size: 12px;
    margin-left: 0;
    font-weight: 300;
    line-height: 44px;
    position: relative;
    vertical-align: middle;
}

.button {
    background-color: #a2f434;
    width: 385px;
    padding: 0;
    margin: 27px 0 16px 0;

    display: inline-block;
    min-width: 247px;
    height: 44px;
    line-height: 44px;
    color: white;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
}

@media (max-height: 660px) {
    .field {
        padding-top: 2px;
    }

    .activation-form input {
        height: 35px;
    }

    .button.logon {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 6px;
        height: 35px;
    }
}

@media (max-width: 610px) {
    .right {
        float: none;
        position: relative;
    }

    .left {
        float: none;
        position: relative;
    }

    .field {
        width: 300px;
    }

    .activation-form {
        width: 300px;
        margin: auto;
    }

    .activation-form input {
        width: 300px;
    }

    .button {
        width: 300px;
    }
}

@media (max-height: 331px) {
    h1 {
        display: none;
    }
}
</style>

